<template>
    <marquee class="announcement-msg" v-if="walletConfig?.announcement?.value">
        {{walletConfig?.announcement?.value}}
    </marquee>
</template>

<script>
export default {
    name: 'WalletAnnoucement',
    inject: ['walletConfig'],
}
</script>